<template>
  <div class="vx-col w-full mb-base" id="account-info-col-1">
    <vx-card title="Generating Reports">
      <div class="vx-col flex-1">
        <div class="grid grid-cols-2 gap-4">
          <!-- PDF Column -->
          <div>
            <h5 class="font-semibold mb-2">PDF</h5>
            <ul>
              <li
                v-for="(item, index) in pdfReports"
                :key="'pdf-' + index"
                class="mb-2"
              >
                <vs-checkbox v-model="selected" :vs-value="item.value">{{
                  item.reportName
                }}</vs-checkbox>
              </li>
            </ul>
          </div>

          <!-- Excel Column -->
          <div>
            <h5 class="font-semibold mb-2">EXCEL</h5>
            <ul>
              <li
                v-for="(item, index) in excelReports"
                :key="'excel-' + index"
                class="mb-2"
              >
                <vs-checkbox v-model="selected" :vs-value="item.value">{{
                  item.reportName
                }}</vs-checkbox>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="flex justify-between flex-wrap mt-5">
        <span />
        <vs-button
          @click="onSetPasswordToOpen()"
          color="success"
          type="filled"
          icon-pack="feather"
          icon="icon-download"
          >Generate Reports</vs-button
        >
      </div>
    </vx-card>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";

import moment from "moment";
import vSelect from "vue-select";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VueApexCharts from "vue-apexcharts";
import analyticsData from "../../ui-elements/card/analyticsData.js";

import axios from "@/axios.js";
import Swal from "sweetalert2";
let timerInterval;

export default {
  props: {
    createPayroll: {
      type: Object,
      required: false,
    },
    isValidate6: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      counter: 0,
      percentage: [0],
      analyticsData,

      reportItems: [
        { value: "PayrollEarnings", reportName: "Earnings", type: "PDF" },
        { value: "PayrollDeductions", reportName: "Deductions", type: "PDF" },
        { value: "PayrollLoans", reportName: "Loans", type: "PDF" },
        {
          value: "PayrollProoflist",
          reportName: "Payroll Prooflist",
          type: "PDF",
        },
        {
          value: "PayrollRegister",
          reportName: "Payroll Register",
          type: "PDF",
        },
        { value: "PayrollBankAdvise", reportName: "Bank Advise", type: "PDF" },
        { value: "Earnings", reportName: "Earnings", type: "EXCEL" },
        { value: "Deductions", reportName: "Deductions", type: "EXCEL" },
        { value: "Loans", reportName: "Loans", type: "EXCEL" },
        { value: "LogHours", reportName: "Prooflist", type: "EXCEL" },
        { value: "Overtime", reportName: "Overtime", type: "EXCEL" },
        { value: "PayRegister", reportName: "PayRegister", type: "EXCEL" },
        {
          value: "PayrollBankRemittance",
          reportName: "Bank Diskette",
          type: "EXCEL",
        },
      ],
      selected: [
        "PayrollEarnings",
        "PayrollDeductions",
        "PayrollLoans",
        "PayrollProoflist",
        "PayrollRegister",
        "PayrollBankAdvise",
        "Earnings",
        "Deductions",
        "Loans",
        "LogHours",
        "Overtime",
        "PayRegister",
        "PayrollBankRemittance",
      ],
      passwordToOpen: "",
    };
  },
  created() {
    this.$store.dispatch("lookup/getAllBankLookup");
  },
  computed: {
    getAllLogHours() {
      return this.$store.state.payroll.getAllLogHours;
    },
    tenantName() {
      return (id) => this.$store.getters["tenants/tenantName"](id);
    },
    getBankLookup() {
      return this.$store.state.lookup.getAllBankLookup;
    },
    bankName() {
      return (id) => this.$store.getters["lookup/bankLookup"](id);
    },
    pdfReports() {
      return this.reportItems.filter((item) => item.type === "PDF");
    },
    excelReports() {
      return this.reportItems.filter((item) => item.type === "EXCEL");
    },
  },
  methods: {
    onGenerateReports() {
      this.percentageReport = [0];
      this.counterReports = 0;
      let tenant = this.tenantName(this.$store.state.AppActiveUser.tenantsId);
      var logoPath = "";

      if (tenant.photoId != null) {
        this.$store
          .dispatch("getFile", tenant.photoId) //Get filePath of Company Logo
          .then((response) => {
            logoPath = response.data.path;
          });
      }

      //Export Report in ZIP File
      const data = {
        serverName: tenant.secretKey,
        dbName: tenant.apiKey,
        userName: "",
        password: "",
        companyCode: tenant.code,
        companyName: tenant.name,
        address: tenant.address,
        photoURL: logoPath,
        createPayrollId: this.createPayroll.createPayrollId,
        printedBy: this.$store.state.AppActiveUser.uid,
        reportName: this.selected,
        payOutDate: moment(this.createPayroll.payOutDate).format("YYYYMMDD"),
        creditDate: moment(this.createPayroll.payOutDate).format("DD MMM yyyy"),
        passwordToOpen: this.passwordToOpen,
        monthName: "",
        yearScope: "",
        reportType: "CURRENT",
        userId: [this.$store.state.AppActiveUser.uid],
      };
      this.$store.dispatch("payroll/GenerateReports", data).then(() => {
        var zipFileName =
          tenant.code +
          "_" +
          moment(this.createPayroll.payOutDate).format("YYYYMMDD") +
          ".zip";
        var pDate = moment(this.createPayroll.payOutDate).format("YYYYMMDD");
        axios
          .get(
            `/api/reports/DownloadFile?dbName=${tenant.code}&fileName=${zipFileName}&payOutDate=${pDate}&reportType=CURRENT`,
            { reportProgress: true, responseType: "blob" }
          )
          .then((response) => {
            this.$vs.loading.close();
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              tenant.code +
                "_" +
                moment(this.createPayroll.payOutDate).format("YYYYMMDD") +
                ".zip"
            );
            document.body.appendChild(link);
            link.click();

            Swal.fire({
              title: "Done",
              html: "Reports Generated",
              icon: "success",
              timer: 2000,
              timerProgressBar: true,
            });
          })
          .catch((error) => {
            this.$alert(error.message, "Error", "error");
          });
      });
    },
    onSetPasswordToOpen() {
      Swal.fire({
        title: "Set Password",
        input: "password",
        inputLabel: "Password",
        inputPlaceholder: "Max of 10 characters",
        inputAttributes: {
          maxlength: 10,
          autocapitalize: "off",
          autocorrect: "off",
        },
      }).then((t) => {
        // console.log(t.value)
        this.passwordToOpen = t.value;
        if (t.value == "") {
          this.$alert(
            "This is an important file and must have a password ",
            "Password Required",
            "info"
          );
        } else {
          this.onOpenWaitingDialog();
        }
      });
    },
    onOpenWaitingDialog() {
      Swal.fire({
        title: "Generating Reports!",
        html: "Please wait while report is generating...",
        timer: 2000,
        showConfirmButton: false,
        didOpen: () => {
          this.onGenerateReports();
        },
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
          // console.log('I was closed by the timer')
        }
      });
    },
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    flatPickr,
    VueApexCharts,
    Swal,
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
